import Slide from "@/components/_types/slide";
import DuoColorBorder from "@/components/buttons/custom-border/duo-color-border";
import { limitDecimalsToString } from "@/components/util/functions";
import Image from "next/image";
import Link from "next/link";
import { FaImage } from "react-icons/fa";

const ColorfulSlider = ({
	slide,
	kind,
	activeGenre,
}: {
	slide: Slide;
	kind: string;
	activeGenre?: any;
}) => {
	return (
		<Link
			className="flex justify-center relative hover:opacity-70"
			style={{ width: "160px", height: "224px" }}
			href={`/${kind}/${slide.id}`}
		>
			<div
				className="absolute rounded-br-md rounded-bl-md bottom-[2px] right-0 h-[50%] w-full z-10"
				style={{
					backgroundImage:
						"linear-gradient(to top, rgba(0,0,0,.8), transparent)",
				}}
			></div>
			<div
				className="relative rounded-[8px] shadow-lg transition-all h-full"
				style={{
					border:
						"2px solid " +
						(slide.cutinScore < 4
							? "#2CC2F9"
							: slide.cutinScore <= 7
								? "#A9F958"
								: "#FE22EA"),
				}}
			>
				{slide.backgroundImage?.code ? (
					<Image
						src={process.env.NEXT_PUBLIC_FILE_URL + slide.backgroundImage?.code}
						alt={slide.title}
						width={158}
						height={218}
						className="rounded-md h-full min-w-[158px] min-h-[218px] max-w-[158px] max-h-[218px]"
					/>
				) : (
					<div
						style={{
							width: 158,
							height: 218,
							backgroundColor: "#000",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<FaImage
							size={"48"}
							color={
								slide.cutinScore < 4
									? "#2CC2F9"
									: slide.cutinScore <= 7
										? "#A9F958"
										: "#FE22EA"
							}
						/>
					</div>
				)}
				<div className="absolute w-full bottom-0 left-0 rounded-xl z-20">
					<div className="rounded-xl px-[12px] w-full py-[6px]">
						{slide.genres &&
							slide.genres.length > 0 &&
							slide.genres[0]?.persianName && (
								<Link
									href={`/${kind}/genres/${
										activeGenre?.name ?? slide.genres[0]?.id
									}`}
									className="w-max block"
								>
									<DuoColorBorder
										id={`colorful-${slide.id}`}
										color={
											slide?.cutinScore < 4
												? "#2CC2F9"
												: slide.cutinScore <= 7
													? "#A9F958"
													: "#FE22EA"
										}
										secondColor={"#FFF"}
										extraClasses={"px-3 py-2 mb-[-10px] hover:opacity-70"}
										direction={"to bottom"}
										containerClasses={"w-max"}
									>
										<p className="font-medium text-[10px]">
											{activeGenre?.persianName ?? slide.genres[0]?.persianName}
										</p>
									</DuoColorBorder>
								</Link>
							)}
						<hr className="my-[16px] opacity-50" />
						<div className="flex justify-between items-center gap-2 w-full">
							<div
								className="text-black font-semiBold px-1 min-w-[30px] h-full rounded-lg text-[20px] text-center  flex-shrink-0"
								style={{
									backgroundColor:
										slide.cutinScore < 4
											? "#2CC2F9"
											: slide.cutinScore <= 7
												? "#A9F958"
												: "#FE22EA",
								}}
							>
								{limitDecimalsToString(slide?.cutinScore, 1)}
							</div>
							<div className="w-[calc(100%_-_50px)]">
								<div className="flex justify-end items-center w-full">
									{/* <span className="text-white text-[13px] font-semibold whitespace-nowrap flex-shrink-0">
										کات اسکور
									</span> */}
									<span
										className="text-white text-[13px] font-semibold text-left truncate block max-w-1/2"
										dir={/[\u0600-\u06FF]/.test(slide.title) ? "rtl" : "ltr"}
										title={slide.title}
									>
										{slide.title}
									</span>
								</div>
								<span className="text-white font-lalezar text-[10px] font-bold">
									از مجموع {slide.totalScore ?? 0} امتیاز
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Link>
	);
};

export default ColorfulSlider;
